import {
  getPaymentFeeForActivePaywayAsNumber,
  getPaymentFeeList,
  isPaymentFeeActive,
  isPaymentFeeLegacyMode,
} from '@/base/domain/paymentFee.domain'

/**
 * Prowizja znana bez wybranego kanału - tylko wtedy, gdy wszystkie kanały mają tę samą stawkę.
 *
 * Kryterium jest to samo, co w `isPaymentFeeDifferent` (`Set(getPaymentFeeList).size`), tylko po
 * przeciwnej stronie: `size === 1` znaczy „jedna stawka dla całego paywalla". Liczymy wprost z listy,
 * a nie przez `getPaymentFeeAsSingleValue`, bo ta funkcja formatuje wynik do stringa z przecinkiem
 * (`Number('1,50')` to `NaN`) i raportuje brak prowizji w danych potwierdzenia.
 */
const getUniformPaymentFee = (paymentData) => {
  const feeList = getPaymentFeeList(paymentData)
  if (new Set(feeList).size !== 1) {
    return 0
  }
  return Number(feeList[0]) || 0
}

export const getTransactionAmount = ({ paymentData = null, confirmationData = null, paywayID = null } = {}) => {
  const baseAmount = Number(paymentData?.transaction?.payAmount) || 0

  if (!isPaymentFeeActive({ paymentData, confirmationData }) || isPaymentFeeLegacyMode(paymentData)) {
    return baseAmount
  }

  // Bez wybranego kanału dokładamy prowizję, o ile jest jedna dla całego paywalla - dokładnie tak,
  // jak liczy ją panel szczegółów (`useOrderDetails.getTransactionPayAmount`). Bez tego kwota
  // zależała od MOMENTU wywołania: `setC2PInitData` leci w `Paywall.onMounted`, gdzie `paywayID`
  // jest jeszcze `null`, chyba że wcześniej zadziałał auto-preselect karty w `PaywayGroup.onMounted`
  // (dzieci montują się przed rodzicem) - ta sama transakcja dawała więc dwie różne kwoty w SDK C2P.
  //
  // Dla Click to Pay jest to bezpieczne również przy różnych stawkach: C2P działa wyłącznie dla kart,
  // a grupa kartowa ma zawsze jeden kanał, więc jej wybór od razu ustawia `paywayID` i prowizja
  // wchodzi do kwoty niżej. Prowizja per kanał nadal dolicza się tylko po wyborze kanału - patrz
  // sekcja „Prowizja płatnika" w CLAUDE.md (PEP-1132).
  if (!paywayID) {
    return baseAmount + getUniformPaymentFee(paymentData)
  }

  return baseAmount + getPaymentFeeForActivePaywayAsNumber({ paymentData, paywayID })
}
